module.exports = __webpack_public_path__ + "img/cosmopolitan.46a357cc.jpg";